import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.immediate.js";
import * as React from 'react';

class SearchableListInput extends React.Component {
  constructor(...args) {
    super(...args);
    this.input = void 0;
    this.focusQueueIndex = void 0;

    this.inputRef = node => {
      this.input = node;
    };
  }

  focus() {
    const {
      input,
      focusQueueIndex
    } = this;

    if (input && !focusQueueIndex) {
      // On iOS Safari, when attempting to focus a fixed (or absolute?)
      // positioned element, the browser jumps to the top of the page.
      //
      // To avoid this behavior, a setImmediate polyfill is used to allow
      // the browser time to finish calculating positioning of the elements
      // or something (not exactly sure).
      //
      // I believe this is the webkit bug to track:
      // https://bugs.webkit.org/show_bug.cgi?id=153224
      // @ts-expect-error - TS2322 - Type 'Immediate' is not assignable to type 'number'.
      this.focusQueueIndex = setImmediate(() => {
        input.focus();
        const cursor = (this.props.value || '').length;
        input.selectionStart = cursor;
        input.selectionEnd = cursor;

        if (this.focusQueueIndex) {
          // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'Immediate'.
          clearImmediate(this.focusQueueIndex);
        }

        this.focusQueueIndex = undefined;
      });
    }
  }

  render() {
    return /*#__PURE__*/React.createElement("input", {
      "aria-activedescendant": this.props.ariaActiveDescendant,
      "aria-autocomplete": "list",
      "aria-expanded": this.props.open,
      "aria-owns": this.props.ariaOwns,
      autoComplete: "off",
      className: this.props.className,
      onChange: this.props.onChange,
      onKeyDown: this.props.onKeyDown // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string | undefined'.
      ,
      placeholder: this.props.placeholder,
      role: "combobox",
      value: this.props.value || '',
      style: this.props.style,
      ref: this.inputRef
    });
  }

}

SearchableListInput.defaultProps = {
  className: 'SearchableList-input',
  style: {}
};
export default SearchableListInput;